import { ExtractCalledActions, WithSelectors } from "../types";

export const useStateActions = <S extends WithSelectors<any>>(
  store: S
): ExtractCalledActions<S>["actions"] => {
  const actions = (store as any).use.actions;
  const wrappedActions = {} as ExtractCalledActions<S>["actions"];

  for (const key of Object.keys(actions)) {
    (wrappedActions as any)[key] = actions[key](); // Call each action
  }

  return wrappedActions;
};
